import React from 'react';
import classnames from 'classnames';
import ReactGA from 'react-ga';

import Toggle from '../common/Toggle';
import Customization from './customization';
import InstallLayover from './InstallLayover';
import Loading from '../common/Loading';
import utils from '../../lib/utils';
import './index.scss';

class Conversations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle:false,
      modalopen:false,
      showsucess:false
    };
    this.conversationslist = [];
  }

  componentDidMount =()=>{
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Web Chat Tab',
      label: 'Web Chat Page'
    });
    if(this.props.business.id) {
      this.props.getWebchatPreference(this.props.business.id);
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.business.isInfoFetched && nextProps.business.isInfoFetched!==this.props.business.isInfoFetched && nextProps.business.id) {
      this.props.getWebchatPreference(nextProps.business.id);
    }
    if(nextProps.webchatconfig.getWebpreference!==true && nextProps.webchatconfig.getWebpreference!==this.props.webchatconfig.getWebpreference){
      if(nextProps.webchatconfig.webchatpreference){
      this.setState({
        toggle:(nextProps.webchatconfig.webchatpreference.channel_status==='ENABLED')?true:false
      })
      }
    }
    if(nextProps.webchatconfig.getWebGreetings!==true && nextProps.webchatconfig.getWebGreetings!==this.props.webchatconfig.getWebGreetings){
      console.log('upload fail', nextProps.webchatconfig);
      if(!nextProps.webchatconfig.uploadFail){
      this.setState({
        showsucess:true
      })
      setTimeout(()=>{this.setState({showsucess:false})},3000)
      }
    }
  }
  ToggleButton=(event)=>{
    console.log(event.target.value);
    this.setState({
      toggle:!this.state.toggle
    },this.props.postWebchatStatus(!this.state.toggle, this.props.business.id, this.props.business.info.EMAIL));
  }
  ValueofToggle=(value)=>{
    if(value){
      return 'ENABLED';
    }else{
      return 'DISABLED';
    }

  }
  ValueofSubheading = (value, domain)=>{
    if(value){
      return 'TrueLark '+this.getHeaderText(domain)+' is now enabled on your web page';
    }else{
      return 'TrueLark '+this.getHeaderText(domain)+' is not visible on your site'
    }
  }

  getHeaderText=(domain)=>{
    if(domain === 'DENTAL'){
      return 'Web to Text';
    }else{
      return 'Web Chat';
    }
  }
  getLinkforDomain=(domain)=>{
    if(domain === 'DENTAL'){
      return 'https://truelark.notion.site/Web-to-Text-Business-Instructions-514cb91084a8473dbec2e0d00bfb1505';
    }else{
      return window.Config.WEBCHAT_CONFIG.SUPPORT_VIDEO;
    }
  }

  openInstallModal = () =>{
    this.setState({
      modalopen:true
    },console.log(this.state))
  }
  closeInstallModal = () =>{
    this.setState({
      modalopen:false
    })
  }

  checkForDisable= ()=>{
    const { webchatconfig } = this.props;
    if(webchatconfig && webchatconfig.webchatpreference && Object.keys(webchatconfig.webchatpreference).length!==0 && webchatconfig.webchatpreference.feature_status === 'DISABLED'){
      return true;
    }
    return false;
  }

  render() {
    const { toggle, modalopen, showsucess } = this.state;
    const { webchatconfig,auth} = this.props;
    const features = utils.getCookie('feature')
    return (
      <div className="webchat">
        {webchatconfig.getWebpreference && 
        <div className="add-campaign_loader">
        <Loading />
        </div>
        } 
        {!webchatconfig.getWebpreference && 
        <>
        <div className={classnames('webchat_title',{'low-title':this.checkForDisable()})} >
          <div className="webchat_title_content">
            <span>{this.getHeaderText(auth.domain)}</span>
          </div>
          {webchatconfig.webchatpreference && Object.keys(webchatconfig.webchatpreference).length!==0 && webchatconfig.webchatpreference.feature_status === 'ENABLED' && 
          <>
          <div className="webchat_title_action">
            <div className="toggle-button">
              <Toggle onClick={this.ToggleButton} data={toggle}/>
              <div className="toggle-data">
                <div className={classnames('head', {'disabled-webcaht ': !toggle})}>{this.ValueofToggle(toggle)}</div>
                <div className="sub-head"> {this.ValueofSubheading(toggle,auth.domain)}</div>
              </div>
            </div>
            <div className="install-button">
              <button className="instruction" onClick={this.openInstallModal}>Install instructions</button>
            </div>
          </div>
          <div className='webchat_title_list'>
            <Customization {...this.props}/>
          </div>
          </>
          }
          {showsucess &&
          <div className="copy-webhook">
            <span className="tick-mark"><i className="material-icons">check</i></span>
            Your changes have been saved.
            </div>
          }
        </div>
        {webchatconfig.webchatpreference && Object.keys(webchatconfig.webchatpreference).length!==0 && webchatconfig.webchatpreference.feature_status === 'DISABLED' &&
            <>
            <div className="form-response_campaign">
            <div className="form-response_campaign_content">
            <div className="upgrade-bar"> <a href="mailto:support@truelark.com">Upgrade </a>to enable {this.getHeaderText(auth.domain)}. Feature details<a class="video-link" href={this.getLinkforDomain(auth.domain)}  target="_blank">here.</a></div>
            </div>
            </div>
            {features && !features.includes('CONTACT_INFO_HIDDEN') && 
            <div className="help-form" style={{textAlign:'center'}}>Reach us at support@truelark.com or call +1-408-582-7010</div>
            }
            </>
          }
        <InstallLayover modelopen ={modalopen} closeInstallModal={this.closeInstallModal} {...this.props} domain={auth.domain}/>
        </>
        }
      </div>
    );
  }
}
export default Conversations;
